__webpack_require__.p = "/wp-content/themes/taylor-foods/dist/";